import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import { useAuth } from "context/authContext";
import { TextField } from "@mui/material";

function Basic() {
  const location = useLocation();
  const { 
    quotation = false, 
    order = false, 
    message = false,
  } = location.state || {};

  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const { login, user, isAuthenticated } = useAuth();

  useEffect(() => {
    if (message) {
      setOpen(true);
    }

    const init = async () => {
      const authenticated = await isAuthenticated();
      console.log("Login: ", authenticated);
      if (authenticated) {
        navigate(`/ofertas`);
        return;
      }
    };

    init();
  }, []);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleSetRememberMe = () => setRememberMe(!rememberMe);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      await login(email, password);
      // O redirecionamento agora é feito dentro da função login no AuthContext
    } catch (err) {
      setError("Falha no login. Por favor, verifique suas credenciais.");
      console.error("Erro de login:", err);
    }
  };

  const snackBar = (
    <Snackbar open={open} autoHideDuration={4000} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
      <MuiAlert onClose={handleClose} severity={message.type} sx={{ width: "100%" }}>
        {message.msg}
      </MuiAlert>
    </Snackbar>
  )

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Entrar
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleSubmit}>
            <MDBox mb={2}>
              <TextField
                type="email"
                label="Email"
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </MDBox>
            <MDBox mb={2}>
              <TextField
                type="password"
                label="Senha"
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </MDBox>
  
            <MDTypography variant="button" color="text">
              Esqueceu sua senha?&nbsp;
              <MDTypography
                component={Link}
                to="/reset-password"
                variant="button"
                color="info"
                fontWeight="medium"
                textGradient
              >
                Redefinir.
              </MDTypography>
            </MDTypography>
            
            {/* COMENTADO PARA IMPLEMENTAÇÃO FUTURA
            <MDBox display="flex" alignItems="center" ml={-1}>
              <Switch checked={rememberMe} onChange={handleSetRememberMe} />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                onClick={handleSetRememberMe}
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Lembrar-me
              </MDTypography>
            </MDBox> */}
            {error && (
              <MDBox mt={2}>
                <MDTypography variant="caption" color="error" fontWeight="light">
                  {error}
                </MDTypography>
              </MDBox>
            )}
            <MDBox mt={4} mb={1}>
              <MDButton variant="gradient" color="info" fullWidth type="submit">
                entrar
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
        {snackBar}
      </Card>
    </BasicLayout>
  );
}

export default Basic;